type ConnectorIconProps = {
  className?: string;
  color?: string;
};

export const ConnectorIcon = ({ className, color }: ConnectorIconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
    >
      <path d="M0.5 0V16C0.5 18.2091 2.29086 20 4.5 20H16.5" />
    </svg>
  );
};
